export default __webpack_public_path__ + "static/media/dashimg.eb4a3dfa.png";